import React from "react";
import { ArrowRight, Sparkles } from "lucide-react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function FindYourBalance() {
  const {
    ref: textRef,
    isVisible: textVisible
  } = useRevealOnScroll();
  const {
    ref: imageRef,
    isVisible: imageVisible
  } = useRevealOnScroll();
  return <section data-section-id="16905" id="your-body-our-expertise-cyprus" className="bg-background text-foreground relative min-h-screen w-full overflow-hidden flex items-center py-20 lg:py-0">
      {}
      <div className="absolute top-0 left-0 w-full h-full overflow-hidden pointer-events-none">
        <div className="absolute top-[-10%] left-[-10%] w-[50vw] h-[50vw] bg-accent/5 rounded-full blur-[120px]" />
        <div className="absolute bottom-[-10%] right-[-10%] w-[40vw] h-[40vw] bg-primary/10 rounded-full blur-[100px]" />
      </div>

      <div className="container mx-auto px-6 lg:px-12 relative z-10 h-full">
        <div className="flex flex-col lg:flex-row items-center h-full gap-12 lg:gap-20">
          
          {}
          <div ref={textRef} className={`w-full lg:w-[60%] flex flex-col justify-center space-y-8 transition-all duration-1000 ease-out ${textVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-10"}`}>
            <div className="space-y-6">
              <div className="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-accent/10 border border-accent/20 text-accent text-sm font-medium w-fit">
                <Sparkles className="w-4 h-4" />
                <span>Expert Care in Limassol & Nicosia</span>
              </div>
              
              <h1 className="font-serif text-5xl md:text-6xl lg:text-7xl leading-[1.1] tracking-tight text-primary ml-8">
                Your body. <br />
                Our expertise. <span className="text-accent font-light">Cyprus.</span>
              </h1>
              
              <p className="text-lg md:text-xl text-secondary max-w-2xl leading-relaxed">
                Bodywerks provides world-class chiropractic and acupuncture care across two convenient locations. Whether you are in Limassol or Nicosia, our specialists are dedicated to your recovery and long-term health.
              </p>
            </div>

            <div className="flex flex-col sm:flex-row gap-4 pt-4">
              <Button asChild size="lg" className="bg-accent text-accent-foreground hover:bg-accent/90 shadow-lg shadow-accent/20 h-14 px-8 text-lg rounded-full w-full sm:w-auto transition-transform hover:scale-105">
                <Link to="https://bodywerkscy.setmore.com">
                  Book Now
                </Link>
              </Button>
              
              <Button asChild variant="outline" size="lg" className="border-accent/30 text-primary hover:bg-accent/10 hover:text-accent h-14 px-8 text-lg rounded-full w-full sm:w-auto backdrop-blur-sm">
                <Link to="/TreatmentsPage">
                  Our Treatments <ArrowRight className="ml-2 w-5 h-5" />
                </Link>
              </Button>
            </div>

            <div className="flex items-center gap-8 pt-8 border-t border-border/40">
              <div>
                <p className="text-3xl font-serif text-primary">2</p>
                <p className="text-sm text-secondary">Clinic Locations</p>
              </div>
              <div>
                <p className="text-3xl font-serif text-primary">5.0</p>
                <p className="text-sm text-secondary">Patient Rating</p>
              </div>
              <div>
                <p className="text-3xl font-serif text-primary">15+</p>
                <p className="text-sm text-secondary">Years Experience</p>
              </div>
            </div>
          </div>

          {}
          <div ref={imageRef} className={`w-full lg:w-[40%] flex justify-center lg:justify-end transition-all duration-1000 delay-300 ease-out ${imageVisible ? "opacity-100 translate-x-0" : "opacity-0 translate-x-10"}`}>
            <div className="relative w-full max-w-md lg:max-w-full aspect-[3/4] lg:aspect-[4/5]">
              {}
              <div className="absolute inset-0 bg-accent/20 rounded-[30%_70%_70%_30%/30%_30%_70%_70%] blur-2xl transform rotate-6 scale-105 opacity-60 animate-pulse" />
              
              <div className="relative h-full w-full overflow-hidden rounded-[2rem_4rem_2rem_4rem] shadow-2xl shadow-primary/10 border border-primary/5 group">
                <div className="absolute inset-0 bg-gradient-to-t from-primary/40 via-transparent to-transparent z-10 opacity-60" />
                <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1609030/img/practitioner_hands_adjustment.png" alt="Artistic high-shutter-speed photo of a practitioner's hands performing a treatment" className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-110" />
                
                {}
                <div className="absolute bottom-8 left-8 z-20 bg-background/80 backdrop-blur-md border border-primary/10 p-4 rounded-2xl shadow-lg max-w-[200px]">
                  <p className="font-serif text-lg text-primary leading-tight">
                    "The gold standard for care in Cyprus."
                  </p>
                  <p className="text-xs text-accent mt-2 font-medium uppercase tracking-wider">
                    — Maria S.
                  </p>
                </div>
              </div>
            </div>
          </div>

        </div>
      </div>
    </section>;
}